module.exports = __webpack_public_path__ + "static/media/image-1.9ac30970.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Apteligent/image-1.png
// module id = 251
// module chunks = 0